module.exports = __webpack_public_path__ + "static/media/internet.735279db.svg";